module.exports = __webpack_public_path__ + "4fec2787df97e086c9bdd38c9fee12a7.pdf";